/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leo_Feature_1Inputs */

const en_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access to industry-leading LLMs`)
};

const id_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses ke LLM terkemuka di industri ini`)
};

const ms_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses kepada LLM peneraju industri`)
};

const ca_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accés a LLM líders en el sector`)
};

const cs_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přístup ke špičkovým LLM`)
};

const da_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adgang til branchens førende LLM'er`)
};

const de_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugriff auf die besten LLMs der Branche`)
};

const et_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juurdepääs valdkonna juhtivale LLM-ile`)
};

const es_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso a LLM líderes de la industria`)
};

const fr_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès aux meilleurs LLM`)
};

const hr_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pristup vodećim velikim jezičnim modelima (LLM-ovima)`)
};

const it_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso a LLM leader del settore`)
};

const lv_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piekļuve nozarē vadošajiem LLM`)
};

const lt_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prieiga prie pramonėje pirmaujančių LLM programų`)
};

const hu_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hozzáférés az iparágvezető LLM-ekhez`)
};

const nl_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toegang tot toonaangevende LLM's`)
};

const nb_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilgang til bransjeledende LLM-er`)
};

const pl_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostęp do najlepszych w branży LLM-ów`)
};

const pt_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso a LLMs líderes do setor`)
};

const ro_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acces la LLM-uri de vârf din industrie`)
};

const sk_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prístup k špičkovým LLM`)
};

const sl_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostop do velikih jezikovnih modelov (LLM)`)
};

const fi_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pääsy alan johtaviin kielimalleihin`)
};

const sv_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillgång till branschledande LLM-utbildningar`)
};

const vi_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sử dụng các LLM hàng đầu`)
};

const tr_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sektör lideri LLM'lere erişim`)
};

const el_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πρόσβαση σε κορυφαία LLMs`)
};

const bg_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Достъп до водещи в бранша LLM`)
};

const ru_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступ к передовым языковым моделям (LLM) отрасли`)
};

const sr_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приступ водећим великим језичким моделима (LLM) у делатности`)
};

const uk_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступ до провідних язикових моделей`)
};

const ka_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ინდუსტრიის წამყვან LLM-ებზე წვდომა`)
};

const hi_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इंडस्ट्री-लीडिंग एलएलएम तक एक्सेस `)
};

const th_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเข้าถึง LLM ชั้นนำของอุตสาหกรรม`)
};

const ko_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`업계 최고의 LLM 이용 가능`)
};

const zh_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`访问行业领先的大型语言模型`)
};

const zh_tw_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獲取業界領先的大型語言模型`)
};

const ja_leo_feature_1 = /** @type {(inputs: Leo_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`業界をリードするLLMへのアクセス`)
};

/**
* | output |
* | --- |
* | "Access to industry-leading LLMs" |
*
* @param {Leo_Feature_1Inputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const leo_feature_1 = /** @type {((inputs?: Leo_Feature_1Inputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leo_Feature_1Inputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_leo_feature_1(inputs)
	if (locale === "ms") return ms_leo_feature_1(inputs)
	if (locale === "ca") return ca_leo_feature_1(inputs)
	if (locale === "cs") return cs_leo_feature_1(inputs)
	if (locale === "da") return da_leo_feature_1(inputs)
	if (locale === "de") return de_leo_feature_1(inputs)
	if (locale === "et") return et_leo_feature_1(inputs)
	if (locale === "es") return es_leo_feature_1(inputs)
	if (locale === "fr") return fr_leo_feature_1(inputs)
	if (locale === "hr") return hr_leo_feature_1(inputs)
	if (locale === "it") return it_leo_feature_1(inputs)
	if (locale === "lv") return lv_leo_feature_1(inputs)
	if (locale === "lt") return lt_leo_feature_1(inputs)
	if (locale === "hu") return hu_leo_feature_1(inputs)
	if (locale === "nl") return nl_leo_feature_1(inputs)
	if (locale === "nb") return nb_leo_feature_1(inputs)
	if (locale === "pl") return pl_leo_feature_1(inputs)
	if (locale === "pt") return pt_leo_feature_1(inputs)
	if (locale === "ro") return ro_leo_feature_1(inputs)
	if (locale === "sk") return sk_leo_feature_1(inputs)
	if (locale === "sl") return sl_leo_feature_1(inputs)
	if (locale === "fi") return fi_leo_feature_1(inputs)
	if (locale === "sv") return sv_leo_feature_1(inputs)
	if (locale === "vi") return vi_leo_feature_1(inputs)
	if (locale === "tr") return tr_leo_feature_1(inputs)
	if (locale === "el") return el_leo_feature_1(inputs)
	if (locale === "bg") return bg_leo_feature_1(inputs)
	if (locale === "ru") return ru_leo_feature_1(inputs)
	if (locale === "sr") return sr_leo_feature_1(inputs)
	if (locale === "uk") return uk_leo_feature_1(inputs)
	if (locale === "ka") return ka_leo_feature_1(inputs)
	if (locale === "hi") return hi_leo_feature_1(inputs)
	if (locale === "th") return th_leo_feature_1(inputs)
	if (locale === "ko") return ko_leo_feature_1(inputs)
	if (locale === "zh") return zh_leo_feature_1(inputs)
	if (locale === "zh-tw") return zh_tw_leo_feature_1(inputs)
	if (locale === "ja") return ja_leo_feature_1(inputs)
	return en_leo_feature_1(inputs)
});